import axios from 'axios'
import $urls from './urls.js'
import Cookies from 'js-cookie'
import router from '@/router'
import store from '@/store'
import qs from 'qs'
import {clearLoginInfo} from '@/utils'
import isPlainObject from 'lodash/isPlainObject'
import {Loading, Message} from 'element-ui'

const http = axios.create();
const timeOut = 600000 // 设置超时10分钟

// 开始加载动画
let loading;
let time = [];

function startLoading() {
  loading = Loading.service({
    lock: true,
    text: ' ',
    background: 'rgba(0,0,0,.1)' // 背景颜色
  })
}

// 结束加载动画
function endLoading() {
  loading.close()
}

// 添加请求拦截器
http.interceptors.request.use(
  config => {
    //  按钮触发加载处理
    if (store.state.loadingBtn) {
      startLoading()
      clearInterval(time)
      time = setTimeout(() => {
        store.state.loadingBtn = false
        endLoading()
        Message.error('数据请求异常,请重试')
      }, timeOut)
    }

    if (isPlainObject(config.data)) {
      if (/^application\/x-www-form-urlencoded/.test(config.headers['content-type'])) {
        config.data = qs.stringify(config.data)
      }
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 添加响应拦截器
http.interceptors.response.use(
  response => {
    //  按钮触发加载处理
    if (store.state.loadingBtn) {
      clearInterval(time);
      time = setTimeout(() => {
        store.state.loadingBtn = false;
        endLoading()
      }, 100)
    }
    if (response.data.code === 401 || response.data.code === 10021) {
      // clearLoginInfo();
      Cookies.remove('3d_token');
      location.reload();
      return Promise.reject(response.data.msg)
    }
    return response
  },
  error => {
    //  按钮触发加载处理
    if (store.state.loadingBtn) {
      clearInterval(time);
      time = setTimeout(() => {
        store.state.loadingBtn = false;
        endLoading()
      }, 100)
    }
    return Promise.reject(error.response || error)
  }
)

/**
 * 异步请求
 * @param {String} method 请求方式
 * @param {String} url 请求地址
 * @param {Object} data 请求数据
 *
 * @returns {Promise}
 */

function request(method, url, _params, responseType, contentType) {
  // 参数处理
  let params = _params || {};
  let ajaxUrl = $urls[url] || url;
  params['_'] = Math.random();

  let ajaxParams = {
    url: ajaxUrl,
    method: method,
    timeout: timeOut,
    withCredentials: false,
    responseType: responseType || '',
    headers: {
      'Accept-Language': Cookies.get('language') || 'zh-CN',
      'token': Cookies.get('3d_token') || '',
      'orgId': sessionStorage.getItem('orgId') || localStorage.getItem('orgId'),
      'mainOrgId': sessionStorage.getItem('mainOrgId') || localStorage.getItem('mainOrgId'),
      'coreParams': sessionStorage.getItem('coreParams') || localStorage.getItem('coreParams')
    }
  }
  if (contentType) {
    ajaxParams.headers['content-type'] = contentType
  }

  switch (method) {
    case 'get':
      ajaxParams.params = params;
      break;
    default:
      ajaxParams.data = params;
      break
  }

  return new Promise((resolve, reject) => {
    http(ajaxParams).then(res => {
      if (res.data.code !== 0) {
        Message.error(res.data.msg || '服务器异常');
        reject(res.data)
      } else {
        resolve(res.data)
      }
    }).catch(error => {
      reject(error.data)
    })
  })
}

function get(url, data, responseType = '',) {
  return request('get', url, data, responseType)
}

function post(url, data) {
  return request('post', url, data)
}

function put(url, data) {
  return request('put', url, data)
}

function patch(url, data) {
  return request('patch', url, data)
}

function del(url, data) {
  return request('delete', url, data)
}

function upload(url, data) {
  return request('post', url, data, '', 'multipart/form-data; boundary=----WebKitFormBoundaryPpdgcovFUIIYuJFz')
}

export default {
  get,
  post,
  put,
  patch,
  del,
  upload
}



// WEBPACK FOOTER //
// ./src/utils/https.js